export const REENTRY_PLANS_LIST_PATH = '/reentry-plans';

export const CASE_PLAN_CREATE_PATH = '/case-plans/create';

export const CASE_PLAN_SECTION_SKELETON_COUNT = 3;

export const buildReentryPlanDetailsPath = (casePlanId) =>
  `${REENTRY_PLANS_LIST_PATH}/details/${casePlanId}`;

export const REENTRY_PLANNING_TABS = {
  ALL_PLANS: 'All Plans',
};

export const CASE_PLAN_EDIT_PLAN_PERMISSION = 'case_plan_edit_plan';
export const CASE_PLAN_MANAGE_ALL_PLANS_PERMISSION = 'case_plan_manage_all_plans';
export const CASE_PLAN_PREVIEW_RELEASE_PERMISSION = 'case_plan_preview_release_access';
/** Create / provision a reentry plan (Create New Plan button + /case-plans/create). */
export const CASE_PLAN_REENTRY_CREATE_PERMISSION = 'case_plan_reentry_create';
/** Staff eligible to be plan editors (search-staff permissions filter). */
export const CASE_PLAN_REENTRY_EDIT_PERMISSION = 'case_plan_reentry_edit';

export const CASE_PLAN_ACCESS_PERMISSIONS = [
  CASE_PLAN_EDIT_PLAN_PERMISSION,
  CASE_PLAN_MANAGE_ALL_PLANS_PERMISSION,
  CASE_PLAN_PREVIEW_RELEASE_PERMISSION,
];

export const CASE_PLAN_EXPORT_SUCCESS_MESSAGE =
  'Your export request has been queued and you will receive the export on your emails';

/**
 * Single source of truth for reentry plan type keys.
 * - feature: LOCATIONS.activeFeatures / side-nav
 * - planType: case-plans API planTypes query + plan.planType
 */
export const REENTRY_PLAN_TYPES = {
  PREVIEW: { feature: 'reentry_plan_preview', planType: 'reentry_preview' },
  MVP: { feature: 'reentry_plan', planType: 'reentry' },
};

const REENTRY_PLAN_TYPE_ENTRIES = Object.values(REENTRY_PLAN_TYPES);

/** Ordered feature keys used for module access / entitlement checks */
export const REENTRY_VISIBILITY_PLAN_TYPES = REENTRY_PLAN_TYPE_ENTRIES.map(
  ({ feature }) => feature,
);

/** Normalizes a feature or planType key to the visibility (feature) key */
export const toVisibilityPlanType = (planTypeKey) => {
  if (planTypeKey == null || planTypeKey === '') {
    return undefined;
  }

  const normalized = String(planTypeKey).trim().toLowerCase();
  return REENTRY_PLAN_TYPE_ENTRIES.find(
    ({ feature, planType }) =>
      feature.toLowerCase() === normalized ||
      planType.toLowerCase() === normalized,
  )?.feature;
};

/** Maps entitled feature keys (or planType aliases) to case-plan API planType values */
export const mapEntitledPlanTypesToApi = (featureKeys = []) =>
  featureKeys
    .map((featureKey) => {
      const visibilityKey = toVisibilityPlanType(featureKey);
      return REENTRY_PLAN_TYPE_ENTRIES.find(
        ({ feature }) => feature === visibilityKey,
      )?.planType;
    })
    .filter(Boolean);

export const REENTRY_PLANS_DEFAULT_PAGE_SIZE = 25;

export const REENTRY_PLANS_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const VIEW_PLAN_LINK_COLOR = 'var(--tonal-palette-cerulean-main-20, #0078A2)';

/** Pendo tracking id for the Create New Plan action on the All Plans table */
export const REENTRY_CREATE_NEW_PLAN_BUTTON_ID = 'create-new-plan-button';

/** Modal detail keys for Honest Jobs community resources from reentry plan `resources` groups. */
export const HONEST_JOBS_RESOURCE_DETAIL_FIELD_KEYS = [
  'Eligibility',
  'Availability',
  'Description',
  'We offer',
  'Languages',
  'Cost',
  'Next Steps',
  'Website',
  'Facebook',
  'Coverage Area',
  'Required',
  'Last Reviewed',
];

/** Modal detail keys for Honest Jobs job listings from reentry plan `jobs` groups. */
export const HONEST_JOBS_JOB_DETAIL_FIELD_KEYS = [
  'Pay Rate',
  'Frequency',
  'Education Level',
  'Description',
];
